const SUPER_ADMIN = 'Super Admin';
const ADMIN = 'Admin';

module.exports = {
  SUPER_ADMIN, ADMIN
};
